<template>
  <div class="footer mt-auto">
    <div class="logo">
      <img src="@/assets/image/logo.svg">
    </div>
    <div class="copyright">
      &copy; Expansium
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style scoped>
    .footer{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 25px;
      background-color: #FFFFFF;
    }
    .footer .logo img{
      max-width: 150px;
    }
    .footer .copyright{
      color: #484848;
      text-transform: uppercase;
      font-weight: bold;
    }
</style>